exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Participants_participants__4gxbk {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  height: 100%; }\n  .Participants_participants__4gxbk .Participants_header__19qQy {\n    display: -webkit-flex;\n    display: flex;\n    margin-bottom: 8px; }\n  .Participants_participants__4gxbk .Participants_user__1QpY2 {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-align-items: center;\n            align-items: center; }\n    .Participants_participants__4gxbk .Participants_user__1QpY2 .Participants_avatar__2PZDL {\n      margin-right: 10px; }\n  .Participants_participants__4gxbk .Participants_mono__2uiMn {\n    font-family: monospace; }\n", ""]);

// exports
exports.locals = {
	"participants": "Participants_participants__4gxbk",
	"header": "Participants_header__19qQy",
	"user": "Participants_user__1QpY2",
	"avatar": "Participants_avatar__2PZDL",
	"mono": "Participants_mono__2uiMn"
};